import { APIErrorWithMessage, ErrorWithMessage } from './types';

const isErrorWithMessage = (error: unknown): error is ErrorWithMessage =>
  typeof error === 'object' &&
  error !== null &&
  'message' in error &&
  typeof (error as Record<string, unknown>).message === 'string';

const isAPIErrorWithMessage = (error: unknown): error is APIErrorWithMessage =>
  typeof error === 'object' &&
  error !== null &&
  'apiErrors' in error &&
  typeof (error as Record<string, unknown>).apiErrors === 'object';

const toErrorWithMessage = (maybeError: unknown): ErrorWithMessage => {
  if (isErrorWithMessage(maybeError)) return maybeError;

  try {
    return new Error(JSON.stringify(maybeError));
  } catch {
    // fallback in case there's an error stringifying the maybeError
    // like with circular references for example.
    return new Error(String(maybeError));
  }
};

const toAPIErrorWithMessage = (maybeError: unknown): APIErrorWithMessage => {
  if (isAPIErrorWithMessage(maybeError)) return maybeError;

  try {
    return { ...new Error(JSON.stringify(maybeError)), apiErrors: [] };
  } catch {
    // fallback in case there's an error stringifying the maybeError
    // like with circular references for example.
    return { ...new Error(String(maybeError)), apiErrors: [] };
  }
};

const getErrorMessage = (error: unknown) => toErrorWithMessage(error).message;

const getAPIErrorMessage = (error: unknown) => toAPIErrorWithMessage(error);

export { getAPIErrorMessage, getErrorMessage };
